export enum TimerStatus {
  INITIAL = 'INITIAL',
  RUNNING = 'RUNNING',
  STOPPED = 'STOPPED',
  PAUSED = 'PAUSED',
  FINISHED = 'FINISHED',
}

export interface TimeState {
  formattedTime: string;
  seconds: number;
  status: TimerStatus;
}
